import React, { useEffect, useState } from 'react'
import { LoadingWave } from '@CommonComponents'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import { ItemGroup } from '../base_comps/ItemGroup'
import { Assessment } from './Assessment'

export const AssessmentSetup = () => {
  const [currentState, dispatch] = useStateValue()
  const [loading, setLoading] = useState(false)

  let pathParts = window.location.pathname.split('/')
  let cnum = pathParts[3]
  let contextId = pathParts[4]
  useEffect(() => {
    async function resetSelectedLinks() {
      await dispatch({
        type: 'assessmentInclusion',
        payload: [],
      })
    }
    resetSelectedLinks()
  }, [])
  useEffect(() => {
    async function getAsmtData(coursenum, contextId, dispatch) {
      setLoading(true)
      try {
        let resp = await client.get(
          endpoints.getAssessments({
            coursenum: coursenum,
            contextId: contextId,
          })
        )
        await dispatch({
          type: 'loadAsmtData',
          assessmentGroups: resp.data.assessmentGroups,
          allActs: resp.data.allActs,
          expandedAsmts: Object.keys(resp.data.assessmentGroups),
          connectedCourses: resp.data.connectedCourses,
        })
        setLoading(false)
      } catch (err) {
        setLoading(false)
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Error"
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      }
    }
    getAsmtData(cnum, contextId, dispatch)
  }, [])

  const checkActSelection = groupPk => {
    let actIds = Object.keys(currentState.assessmentGroups[groupPk].acts)
    if (currentState.selectedAssessments.length < 1) {
      return false
    }
    let groupChecked = actIds.every(id =>
      currentState.selectedAssessments.map(elem => elem.actPk).includes(id)
    )
    return groupChecked
  }

  const handleCheckChange = (
    groupPk,
    asmtGroups,
    selAsmts,
    selected,
    dispatch
  ) => {
    let actIds = Object.keys(asmtGroups[groupPk].acts)
    let selectedIds = selAsmts
    if (selected) {
      actIds.forEach(function (actId) {
        selectedIds = selectedIds.filter(item => item.actPk !== actId)
      })
    } else {
      actIds.forEach(function (actId) {
        if (!selectedIds.map(elem => elem.actPk).includes(actId)) {
          selectedIds.push(asmtGroups[groupPk]['acts'][actId])
        }
      })
    }

    dispatch({
      type: 'assessmentGroupSelection',
      selectedAssessments: selectedIds,
    })
  }

  const handleCollapseChange = (groupPk, expandedAsmts, expanded, dispatch) => {
    let expActIds = expandedAsmts
    if (expanded) {
      expActIds = expandedAsmts.filter(id => id !== groupPk)
    } else {
      expActIds.push(groupPk)
    }
    dispatch({
      type: 'expandAssessments',
      payload: expActIds,
    })
  }

  const displayAsmts = actArray =>
    actArray
      .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
      .map(function (act) {
        return (
          <div key={act.actPk}>
            <Assessment
              title={act.title}
              inCanvas={act.inCanvas}
              canvasId={act.canvasId}
              actPk={act.actPk}
            />
          </div>
        )
      })

  return (
    <React.Fragment>
      {loading ? (
        <div className="d-flex justify-content-center">
          <LoadingWave />
        </div>
      ) : (
        Object.entries(currentState.assessmentGroups)
          .sort((a, b) => (a[1].sortOrder > b[1].sortOrder ? 1 : -1))
          .map(function (entry) {
            let groupPk = entry[1].pk
            let acts = entry[1].acts
            let actsArray = Object.keys(acts).map(i => acts[i])
            if (Object.keys(entry[1].acts).length) {
              let selected = checkActSelection(groupPk)
              let expanded = currentState.expandedAsmts.includes(groupPk)
              return (
                <ItemGroup
                  key={groupPk}
                  childCompsFunc={displayAsmts}
                  childData={[actsArray]}
                  linksPosting={currentState.linksPosting}
                  linksPosted={currentState.linksPosted}
                  handleCheckChange={handleCheckChange}
                  handleCollapseChange={handleCollapseChange}
                  itemId={groupPk}
                  itemTitle={entry[1].title}
                  selected={selected}
                  expandedArray={currentState.expandedAsmts}
                  selectedArray={currentState.selectedAssessments}
                  allGroups={currentState.assessmentGroups}
                  dispatch={dispatch}
                  expanded={expanded}
                />
              )
            }
          })
      )}
    </React.Fragment>
  )
}
